import { combineReducers } from 'redux';

import { INVENTORY_SET_INVENTORY_SETTINGS } from '../../actions/inventory/advancedInventorySettings/constants';
import createReducer from '../../utils/createReducer';

export const advancedInventorySettings = createReducer(
  {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    advanced_transfer: false,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    advanced_purchase_order: false,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    advanced_adjustment: false,
  },
  {
    [INVENTORY_SET_INVENTORY_SETTINGS]: (draft, { payload }) =>
      // TODO: createReducer must be better typed
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.settings,
  }
);

export default combineReducers({
  permissions: advancedInventorySettings,
});
